/**
 * Csv Schema of Carga
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'

/* TODO: review generated schema */
export class CsvCargaSchema extends Schema {
  readonly name = 'CsvCarga'

  readonly fieldSet: FieldSet<Carga> = {
    idCargaPk: schema => schema.model.idCargaPk,
    sistema1: schema => schema.model.sistema1?.$id ?? null,
    sistema2: schema => schema.model.sistema2?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    auditoria: schema => schema.model.auditoria?.$id ?? null,
    endereco: schema => schema.model.endereco?.$id ?? null,
    motorista: schema => schema.model.motorista?.$id ?? null,
    tipoOcorrencia: schema => schema.model.tipoOcorrencia?.$id ?? null,
    posicaoMotorista: schema => schema.model.posicaoMotorista?.$id ?? null,
    responsavelFilial1: schema => schema.model.responsavelFilial1?.$id ?? null,
    responsavelFilial2: schema => schema.model.responsavelFilial2?.$id ?? null,
    sistema3: schema => schema.model.sistema3?.$id ?? null,
    sistema4: schema => schema.model.sistema4?.$id ?? null,
    statusCarga: schema => schema.model.statusCarga?.$id ?? null,
    tipoPessoaRecebedor: schema =>
      schema.model.tipoPessoaRecebedor?.$id ?? null,
    danfe: schema => schema.model.danfe,
    nroNotaFiscal: schema => schema.model.nroNotaFiscal,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    ativo: schema => Helper.bool(schema.model.ativo),
    finalizadoViaWeb: schema => Helper.bool(schema.model.finalizadoViaWeb),
    reprocessarRedesul: schema => Helper.bool(schema.model.reprocessarRedesul),
    processouEasyDoc: schema => Helper.bool(schema.model.processouEasyDoc),
    qtdPaleteEntregue: schema => schema.model.qtdPaleteEntregue,
    qtdPaleteRetirado: schema => schema.model.qtdPaleteRetirado,
    nomeRecebedor: schema => schema.model.nomeRecebedor,
    documentoRecebedor: schema => schema.model.documentoRecebedor,
    rgRecebedor: schema => schema.model.rgRecebedor,
    idCargaApp: schema => schema.model.idCargaApp,
    codigoBarra: schema => schema.model.codigoBarra,
    placaVeiculo: schema => schema.model.placaVeiculo,
    tipoVeiculo: schema => schema.model.tipoVeiculo,
    nomeMotorista: schema => schema.model.nomeMotorista,
    serialNumber: schema => schema.model.serialNumber,
    cte: schema => schema.model.cte,
    protocolSsw: schema => schema.model.protocolSsw,
    sigla: schema => schema.model.sigla,
    cpfMotorista: schema => schema.model.cpfMotorista,
    cdCorreio: schema => schema.model.cdCorreio,
    xpedido: schema => schema.model.xpedido,
    distanciaParaDestinoEmMetros: schema =>
      schema.model.distanciaParaDestinoEmMetros,
    duracaoParaDestinoEmSegundos: schema =>
      schema.model.duracaoParaDestinoEmSegundos,
    pontoReferenciaEntrega: schema => schema.model.pontoReferenciaEntrega,
    dataEmissaoDanfe: schema => Helper.datetime(schema.model.dataEmissaoDanfe),
    dataInicioEntrega: schema =>
      Helper.datetime(schema.model.dataInicioEntrega),
    dataFinalizacao: schema => Helper.datetime(schema.model.dataFinalizacao),
    observacao: schema => schema.model.observacao,
    latitudeEntrega: schema => schema.model.latitudeEntrega,
    longitudeEntrega: schema => schema.model.longitudeEntrega,
    devolvida: schema => Helper.bool(schema.model.devolvida),
    latitudeCheckIn: schema => schema.model.latitudeCheckIn,
    longitudeCheckIn: schema => schema.model.longitudeCheckIn,
    dataCheckIn: schema => Helper.datetime(schema.model.dataCheckIn),
    dataPrevisao: schema => Helper.datetime(schema.model.dataPrevisao),
    possuiDanfe: schema => Helper.bool(schema.model.possuiDanfe),
    criadoViaPainel: schema => Helper.bool(schema.model.criadoViaPainel),
    dataBaixaSistema: schema => Helper.datetime(schema.model.dataBaixaSistema),
    dataRemocao: schema => Helper.datetime(schema.model.dataRemocao),
    distanciaCheckInEmMetros: schema => schema.model.distanciaCheckInEmMetros,
    distanciaEntregaEmMetros: schema => schema.model.distanciaEntregaEmMetros,
  }
}
